import type { OrganizationInviteDto } from "../../../../../../autogen/bff-api";

export type SameLegalEntityOf = (organizationId: string) => string[];

const belongTogether = (a: string, b: string, sameLegalEntityOf: SameLegalEntityOf) =>
  a === b || sameLegalEntityOf(a).includes(b) || sameLegalEntityOf(b).includes(a);

export const groupByCompany = (
  invites: OrganizationInviteDto[],
  sameLegalEntityOf: SameLegalEntityOf,
): OrganizationInviteDto[][] =>
  invites.reduce<OrganizationInviteDto[][]>((companies, invite) => {
    const company = companies.find((candidate) =>
      candidate.some((member) => belongTogether(member.organizationId, invite.organizationId, sameLegalEntityOf)),
    );
    if (company) company.push(invite);
    else companies.push([invite]);
    return companies;
  }, []);

export const companyContaining = (
  companies: OrganizationInviteDto[][],
  organizationId: string,
  sameLegalEntityOf: SameLegalEntityOf,
): OrganizationInviteDto[] | undefined =>
  companies.find((company) =>
    company.some((member) => belongTogether(member.organizationId, organizationId, sameLegalEntityOf)),
  );
